import { useLanguage, getLanguageDisplayName } from '../i18n';

interface LanguageSwitcherProps {
  className?: string;
}

export function LanguageSwitcher({ className = '' }: LanguageSwitcherProps) {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'zh' : 'en');
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`px-3 py-1.5 border border-white/30 text-white/90 rounded-md hover:border-[#C6A667] hover:text-[#C6A667] transition-colors duration-300 ${className}`}
      title={`Switch to ${language === 'en' ? 'Chinese' : 'English'}`}
    >
      {getLanguageDisplayName(language === 'en' ? 'zh' : 'en')}
    </button>
  );
}
